import React from 'react';
import ReactDOM from 'react-dom/client';
import "bootstrap/dist/css/bootstrap.min.css";
import './styles/globals.scss';
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import 'boxicons/css/boxicons.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './styles/main.scss';
import './styles/common.scss';
import './styles/custom.scss';
import './styles/responsive.scss'
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import GlobalErrorBoundary from './components/error/globalErrorBoundary';
import { setupInterceptors } from './config/interceptors';

window.addEventListener(
  "error",
  (e: ErrorEvent) => {
    const target = e.target as HTMLElement | null;

    // Ensure it's a valid element with a tagName
    if (target && ("tagName" in target)) {
      const tag = (target.tagName as string).toUpperCase();

      if (tag === "LINK" || tag === "SCRIPT") {
        console.warn("Chunk load failed — forcing app reload...");
        window.location.reload();
      }
    }
  },
  true // capture phase is required to catch resource loading errors
);

setupInterceptors();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <BrowserRouter>
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
